export default function HeroBanner() {
    return (
        <div className="container m-auto my-12">
            <h1 className="text-center font-bold md:text-[55px]/[65px] text-3xl lg:w-11/12 mx-auto">
                <span>Battle-Tested </span>
                <span className="olm-gradient-text">Direct Mail</span>
                <span> Solutions for Maximum Impact</span>
            </h1>
        </div>
    )
}
